import React from 'react';

const Skeleton = ({ className = '', type = 'rect', width, height, style = {} }) => {
  const baseStyle = {
    width: width || '100%',
    height: height || (type === 'title' ? '1.5rem' : type === 'text' ? '1rem' : '100%'),
    ...style
  };

  const typeClass = type === 'circle' ? 'skeleton-circle' : 
                    type === 'title' ? 'skeleton-title' : 
                    type === 'text' ? 'skeleton-text' : 
                    type === 'card' ? 'skeleton-card' : '';

  return (
    <div 
      className={`skeleton ${typeClass} ${className}`} 
      style={baseStyle}
    />
  );
};

export default Skeleton;
